import React, { Component } from "react";
import Modal from "react-responsive-modal";

class CustomModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { props } = this;
    return (
      <Modal
        open={props.open}
        onClose={props.onCloseModal}
        closeOnOverlayClick={false}
        center
      >
        <div className="on-setting-modal">
          {/* <span dangerouslySetInnerHTML={{ __html: props.text }} /> */}
          {!!props.renderHtmlText ? (
            <span dangerouslySetInnerHTML={{ __html: props.text }} />
          ) : (
            <h6>{props.text}</h6>
          )}

          <table class="mapping_table">
            <thead>
              <tr>
                <th class="mapping_table_th">Product Name</th>
                <th class="mapping_table_th">Product Code</th>
                <th class="mapping_table_th">Quantity</th>
                <th class="mapping_table_th">Supply Unit</th>
              </tr>
            </thead>
            <tbody>
              {props?.data?.digital_order_line_items.map((data) => (
                <tr>
                  <td class="mapping_table_td">{data?.product_master.product_name}</td>
                  <td class="mapping_table_td">{data?.product_master.material_code}</td>
                  <td class="mapping_table_td">{data?.quantity}</td>
                  <td class="mapping_table_td">{data?.plant_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <br></br>
          <div className="on-setting-modal-buttons">
            {!!props.showCancel && (
              <button onClick={props.onCloseModal}>Cancel</button>
            )}
            {!!props.showChangeProduct && (
              <button onClick={props.onNewButtonClick}>
                Change Product mapping
              </button>
            )}
            <button onClick={props.onOkModal}>
              {props.okBtnText ? props.okBtnText : "Ok"}
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default CustomModal;
